<template>
  <div class="confirm-order-new">
    <!-- 顶部导航栏 -->
    <div class="nav-header">
      <van-nav-bar 
        title="确认订单" 
        left-arrow 
        @click-left="goBack"
        :border="false"
      >
        <template #title>
          <div class="nav-title">
            <i class="title-icon">📋</i>
            <span>确认订单</span>
          </div>
        </template>
      </van-nav-bar>
    </div>

    <div class="main-content">
      <!-- 登机牌样式的订单信息卡片 -->
      <div class="boarding-pass">
        <div class="pass-header">
          <div class="airline-info">
            <i class="plane-icon">✈️</i>
            <span class="pass-title">贵宾厅服务单</span>
          </div>
          <div class="service-number">
            <span>服务码: {{ generateServiceCode() }}</span>
          </div>
        </div>
        
        <div class="pass-content">
          <div class="flight-route">
            <div class="airport-info">
              <div class="airport-code">{{ getAirportCode() }}</div>
              <div class="airport-name">{{ airport }}</div>
            </div>
            <div class="route-line">
              <div class="plane-path">
                <i class="route-plane">✈</i>
                <div class="path-line"></div>
              </div>
            </div>
            <div class="destination">
              <div class="destination-code">VIP</div>
              <div class="destination-name">贵宾厅</div>
            </div>
          </div>
          
          <div class="service-details">
            <div class="detail-row">
              <span class="label">服务日期</span>
              <span class="value">{{ formatDate(orderForm.memberServiceOrder.usageTime) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">服务区域</span>
              <span class="value">{{ room }}</span>
            </div>
            <div class="detail-row">
              <span class="label">服务人数</span>
              <span class="value">{{ orderForm.consumerList.length }} 人</span>
            </div>
            <div class="detail-row">
              <span class="label">联系电话</span>
              <span class="value">{{ orderForm.memberServiceOrder.linkmanTel }}</span>
            </div>
          </div>
        </div>
        
        <div class="pass-divider">
          <div class="perforation"></div>
        </div>
      </div>

      <!-- 乘客信息列表 -->
      <div class="passengers-info">
        <div class="section-title">
          <i class="section-icon">👥</i>
          <h3>乘客信息</h3>
        </div>
        
        <div class="passenger-cards">
          <div 
            class="passenger-card" 
            v-for="(passenger, index) in orderForm.consumerList" 
            :key="index"
            :style="{ animationDelay: index * 0.1 + 's' }"
          >
            <div class="card-header">
              <div class="passenger-avatar">
                <i class="avatar-icon">👤</i>
              </div>
              <div class="passenger-basic">
                <h4>{{ passenger.name }}</h4>
                <p>乘客 {{ index + 1 }}</p>
              </div>
              <div class="passenger-status" v-if="passenger.pwdCode">
                <div class="status-badge">
                  <i class="check-icon">✅</i>
                  <span>已验证</span>
                </div>
              </div>
            </div>
            
            <div class="card-details">
              <div class="detail-grid">
                <div class="detail-item">
                  <i class="detail-icon">📱</i>
                  <span class="detail-label">手机号</span>
                  <span class="detail-value">{{ formatPhone(passenger.tel) }}</span>
                </div>
                <div class="detail-item">
                  <i class="detail-icon">🆔</i>
                  <span class="detail-label">身份证</span>
                  <span class="detail-value">{{ formatIdCard(passenger.idCardNum) }}</span>
                </div>
                <div class="detail-item" v-if="passenger.pwdCode">
                  <i class="detail-icon">🎫</i>
                  <span class="detail-label">兑换码</span>
                  <span class="detail-value">{{ passenger.pwdCode }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 价格明细 -->
      <div class="price-summary">
        <div class="summary-header" @click="togglePriceDetail">
          <h3>费用明细</h3>
          <div class="toggle-btn">
            <span>{{ showDetail ? '收起' : '展开' }}</span>
            <van-icon :name="showDetail ? 'arrow-up' : 'arrow-down'" />
          </div>
        </div>
        
        <div class="price-overview">
          <div class="price-item">
            <span class="price-label">服务费用</span>
            <span class="price-value">¥{{ orderForm.memberServiceOrder.totalAmount }}</span>
          </div>
          <div class="price-item" v-if="discountAmount > 0">
            <span class="price-label">兑换码优惠</span>
            <span class="price-value discount">-¥{{ discountAmount }}</span>
          </div>
        </div>
        
        <div class="price-detail" v-show="showDetail">
          <div class="detail-list">
            <div class="detail-item" v-for="(passenger, index) in orderForm.consumerList" :key="index">
              <span class="passenger-name">{{ passenger.name }}</span>
              <span class="passenger-price">
                <span v-if="passenger.pwdCode" class="free-tag">兑换码抵扣</span>
                <span v-else>¥{{ passenger.costAmount || parice }}</span>
              </span>
            </div>
          </div>
        </div>
        
        <div class="total-amount">
          <span class="total-label">应付金额</span>
          <span class="total-price">¥{{ orderForm.memberServiceOrder.realAmount }}</span>
        </div>
      </div>
    </div>

    <!-- 底部支付区域 -->
    <div class="payment-section">
      <div class="payment-info">
        <div class="amount-display">
          <span class="amount-label">总计</span>
          <span class="amount-value">¥{{ orderForm.memberServiceOrder.realAmount }}</span>
        </div>
        <div class="pay-button" @click="submitOrder" :class="{ loading: isSubmitting }">
          <i class="pay-icon" v-if="!isSubmitting">💳</i>
          <van-loading v-if="isSubmitting" size="20px" color="white" />
          <span>{{ isSubmitting ? '提交中...' : '立即支付' }}</span>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'ConfirmOrderNew',
  data() {
    return {
      orderForm: {
        memberServiceOrder: {},
        consumerList: []
      },
      airport: '',
      room: '',
      parice: 0,
      showDetail: false,
      isSubmitting: false
    }
  },
  
  computed: {
    discountAmount() {
      let discount = 0;
      this.orderForm.consumerList.forEach(passenger => {
        if (passenger.pwdCode) {
          discount += (passenger.costAmount || this.parice);
        }
      });
      return discount;
    }
  },
  
  mounted() {
    this.initOrderData();
  },
  
  methods: {
    // 初始化订单数据
    initOrderData() {
      if (this.$route.query.user) {
        this.orderForm = JSON.parse(this.$route.query.user);
      }
      this.airport = this.$route.query.airport || '';
      this.room = this.$route.query.room || '';
      
      // 计算单价
      if (this.orderForm.consumerList.length > 0) {
        this.parice = this.orderForm.consumerList[0].costAmount || 0;
      }
    },
    
    // 生成服务码
    generateServiceCode() {
      const date = new Date();
      const dateStr = date.getFullYear().toString().substr(-2) + 
                     (date.getMonth() + 1).toString().padStart(2, '0') + 
                     date.getDate().toString().padStart(2, '0');
      const timeStr = date.getHours().toString().padStart(2, '0') + 
                     date.getMinutes().toString().padStart(2, '0');
      return `VIP${dateStr}${timeStr}`;
    },
    
    // 获取机场代码
    getAirportCode() {
      if (this.airport.includes('上海')) return 'SHA';
      if (this.airport.includes('北京')) return 'PEK';
      if (this.airport.includes('深圳')) return 'SZX';
      if (this.airport.includes('广州')) return 'CAN';
      if (this.airport.includes('成都')) return 'CTU';
      return 'VIP';
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const weekday = weekdays[date.getDay()];
      return `${year}-${month}-${day} ${weekday}`;
    },
    
    // 格式化手机号
    formatPhone(phone) {
      if (!phone) return '';
      return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
    },
    
    // 格式化身份证号
    formatIdCard(idCard) {
      if (!idCard) return '';
      return idCard.replace(/(\d{6})(\d{8})(\d{4})/, '$1********$3');
    },
    
    // 切换价格明细显示
    togglePriceDetail() {
      this.showDetail = !this.showDetail;
    },
    
    // 返回上一页
    goBack() {
      this.$router.back();
    },
    
    // 提交订单
    submitOrder() {
      if (this.isSubmitting) return;
      
      console.log('用户数据', this.orderForm);
      this.isSubmitting = true;
      
      this.request({
        url: '/order/order/member-service-order/H5SaveOrder.json',
        method: 'POST',
        data: this.orderForm
      }).then(res => {
        console.log('订单信息：', res);
        this.isSubmitting = false;
        
        if (res.code == 200) {
          if (res.data.orderMaster.totalAmount === 0) {
            // 免费订单，显示支付中提示
            this.$toast.loading({
              message: '支付中...',
              forbidClick: true,
            });
            
            setTimeout(() => {
              this.$router.push({
                path: '/paySuccess'
              });
            }, 3000);
                      } else {
              // 需要支付，直接跳转到支付页面
              this.$router.push({
                path: '/pay-new',
                query: {
                  phone: this.orderForm.memberServiceOrder.linkmanTel,
                  orderNo: res.data.orderMaster.profOrderNo,
                  cost: res.data.orderMaster.totalAmount
                }
              });
            }
        } else {
          this.$toast(res.msg || '订单提交失败，请重试');
        }
      }).catch(error => {
        console.error('提交订单失败:', error);
        this.isSubmitting = false;
        this.$toast('网络异常，请检查网络连接');
      });
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-order-new {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  
  .nav-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    
    .van-nav-bar {
      background: transparent;
      
      .nav-title {
        display: flex;
        align-items: center;
        gap: 8px;
        
        .title-icon {
          font-size: 20px;
        }
      }
    }
  }
  
  .main-content {
    padding: 20px 15px;
    
    // 登机牌样式
    .boarding-pass {
      background: white;
      border-radius: 20px;
      margin-bottom: 20px;
      overflow: hidden;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      animation: slideInUp 0.6s ease-out;
      
      .pass-header {
        background: linear-gradient(135deg, #1989fa 0%, #0984e3 100%);
        color: white;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .airline-info {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .plane-icon {
            font-size: 24px;
          }
          
          .pass-title {
            font-size: 18px;
            font-weight: 600;
          }
        }
        
        .service-number {
          font-size: 12px;
          opacity: 0.9;
        }
      }
      
      .pass-content {
        padding: 24px 20px;
        
        .flight-route {
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          
          .airport-info,
          .destination {
            text-align: center;
            
            .airport-code,
            .destination-code {
              font-size: 24px;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 4px;
            }
            
            .airport-name,
            .destination-name {
              font-size: 12px;
              color: #7f8c8d;
            }
          }
          
          .route-line {
            flex: 1;
            margin: 0 20px;
            
            .plane-path {
              position: relative;
              display: flex;
              align-items: center;
              
              .route-plane {
                font-size: 20px;
                color: #1989fa;
                z-index: 2;
                background: white;
                padding: 0 8px;
              }
              
              .path-line {
                flex: 1;
                height: 2px;
                background: linear-gradient(90deg, #1989fa 0%, #3498db 100%);
                position: absolute;
                width: 100%;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
        
        .service-details {
          .detail-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;
            border-bottom: 1px solid #ecf0f1;
            
            &:last-child {
              border-bottom: none;
            }
            
            .label {
              color: #7f8c8d;
              font-size: 14px;
            }
            
            .value {
              color: #2c3e50;
              font-weight: 500;
            }
          }
        }
      }
      
      .pass-divider {
        height: 20px;
        background: #f8f9fa;
        position: relative;
        
        .perforation {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 2px;
          background: repeating-linear-gradient(
            90deg,
            transparent,
            transparent 5px,
            #ddd 5px,
            #ddd 10px
          );
          transform: translateY(-50%);
        }
        
        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          width: 20px;
          height: 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          transform: translateY(-50%);
        }
        
        &::before {
          left: -10px;
        }
        
        &::after {
          right: -10px;
        }
      }
    }
    
    // 乘客信息
    .passengers-info {
      margin-bottom: 20px;
      
      .section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        
        .section-icon {
          font-size: 20px;
        }
        
        h3 {
          color: white;
          font-size: 18px;
          font-weight: 600;
        }
      }
      
      .passenger-cards {
        .passenger-card {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 16px;
          padding: 20px;
          margin-bottom: 12px;
          backdrop-filter: blur(10px);
          animation: slideInRight 0.5s ease-out both;
          
          .card-header {
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            
            .passenger-avatar {
              width: 48px;
              height: 48px;
              background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 12px;
              
              .avatar-icon {
                font-size: 20px;
                color: white;
              }
            }
            
            .passenger-basic {
              flex: 1;
              
              h4 {
                font-size: 16px;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 4px;
              }
              
              p {
                font-size: 12px;
                color: #7f8c8d;
              }
            }
            
            .passenger-status {
              .status-badge {
                display: flex;
                align-items: center;
                gap: 4px;
                background: rgba(39, 174, 96, 0.1);
                padding: 4px 8px;
                border-radius: 12px;
                
                .check-icon {
                  font-size: 12px;
                }
                
                span {
                  font-size: 12px;
                  color: #27ae60;
                  font-weight: 500;
                }
              }
            }
          }
          
          .card-details {
            .detail-grid {
              display: grid;
              gap: 12px;
              
              .detail-item {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 8px 12px;
                background: #f8f9fa;
                border-radius: 8px;
                
                .detail-icon {
                  font-size: 14px;
                  width: 20px;
                  text-align: center;
                }
                
                .detail-label {
                  font-size: 12px;
                  color: #7f8c8d;
                  min-width: 50px;
                }
                
                .detail-value {
                  font-size: 14px;
                  color: #2c3e50;
                  font-weight: 500;
                  flex: 1;
                }
              }
            }
          }
        }
      }
    }
    
    // 价格明细
    .price-summary {
      background: rgba(255, 255, 255, 0.95);
      border-radius: 16px;
      padding: 20px;
      backdrop-filter: blur(10px);
      animation: slideInUp 0.6s ease-out;
      
      .summary-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        cursor: pointer;
        
        h3 {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
        }
        
        .toggle-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          color: #1989fa;
          font-size: 14px;
        }
      }
      
      .price-overview {
        .price-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          
          .price-label {
            color: #7f8c8d;
            font-size: 14px;
          }
          
          .price-value {
            font-weight: 500;
            color: #2c3e50;
            
            &.discount {
              color: #27ae60;
            }
          }
        }
      }
      
      .price-detail {
        border-top: 1px solid #ecf0f1;
        margin-top: 16px;
        padding-top: 16px;
        
        .detail-list {
          .detail-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6px 0;
            
            .passenger-name {
              color: #7f8c8d;
              font-size: 14px;
            }
            
            .free-tag {
              background: #27ae60;
              color: white;
              padding: 2px 8px;
              border-radius: 10px;
              font-size: 12px;
            }
          }
        }
      }
      
      .total-amount {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 16px;
        border-top: 2px solid #ecf0f1;
        margin-top: 16px;
        
        .total-label {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
        }
        
        .total-price {
          font-size: 24px;
          font-weight: 600;
          color: #e74c3c;
        }
      }
    }
  }
  
  // 底部支付区域
  .payment-section {
    position: sticky;
    bottom: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    padding: 16px 20px;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
    
    .payment-info {
      display: flex;
      align-items: center;
      gap: 16px;
      
      .amount-display {
        flex: 1;
        
        .amount-label {
          display: block;
          font-size: 14px;
          color: #7f8c8d;
          margin-bottom: 4px;
        }
        
        .amount-value {
          font-size: 24px;
          font-weight: 600;
          color: #e74c3c;
        }
      }
      
      .pay-button {
        background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
        color: white;
        padding: 14px 32px;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 140px;
        justify-content: center;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(39, 174, 96, 0.3);
        }
        
        &.loading {
          background: #bdc3c7;
          cursor: not-allowed;
          
          &:hover {
            transform: none;
            box-shadow: none;
          }
        }
        
        .pay-icon {
          font-size: 18px;
        }
      }
    }
  }
  

}

// 动画
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}


</style> 